<template>
    <div>
        <template v-if="hasNodes">
            <ul class="list-group list-group-flush"
                v-for="(node, idx) in nodes"
                :key="`list-group-${node?.id ?? '1'}-${idx}`">
                <li class="list-group-item">{{node.name}}</li>
                <ul class="list-group list-group-flush" v-if="node.children">
                    <a v-for="(child, idxChild) in node.children"
                        :key="`list-group-item-${child?.id ?? '1'}-${idxChild}`"
                        v-if="child.url || child.filename"
                        :href="child.url ? child.url : getFormatUrlAPI(child.filename)"
                        target="_blank"
                        class="list-group-item">
                        {{child.name}}
                    </a>
                </ul>
            </ul>
        </template>
        <template v-else-if="showEmptyMessage">
            <div class="text-center alert" :class="classEmptyMessage" role="alert">
                {{ $t(emptyMessage) }}
            </div>
        </template>
    </div>
</template>

<script type="text/javascript">
    import GlobalMixin from '@/app/shared/mixins/global';

    export default {
        name: 'TreeGroupedLinks',
        mixins: [
            GlobalMixin
        ],
        components: {

        },
        props: {
            nodes: {
                type: Array,
                required: true,
            },
            showEmptyMessage: {
                type: Boolean,
                default: true,
            },
            emptyMessage: {
                type: String,
                default: 'global.no-data',
            },
            classEmptyMessage: {
                type: String,
                default: 'alert-light',
            }
        },
        data()
        {
            return {

            }
        },
        mounted() {

        },
        computed: {
            hasNodes() {
                return !!this.nodes.length;
            }
        },
        methods: {

        },
    }
</script>

<style lang="scss" scoped>
@import "@styles/_theme.scss";
.list-group {
    .list-group-item {
        padding: 0.4rem 0 0.4rem .75rem;
        font-family: $city-bold-font-family;
    }
    > li.list-group-item {
        padding-left: 0;
    }

    a.list-group-item {
        font-family: $city-font-family;
        font-size: 0.875rem;
    }
}

</style>
